/* libs/shared/src/lib/ui/sidenav/sidenav.component.scss */
.ai-assistant-item {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
  gap: 10px;
}
.ai-assistant-item:hover {
  background-color: #f5f7fa;
}
.ai-assistant-item:hover .ai-assistant-icon-wrapper {
  background:
    linear-gradient(
      135deg,
      #4285f4 0%,
      #9b72f2 25%,
      #d96570 50%,
      #f6a045 75%,
      #34a853 100%);
  background-size: 200% 200%;
  animation: ai-gradient-rotate 4s linear infinite;
}
.ai-assistant-item:hover .ai-assistant-icon {
  color: white;
  animation: ai-sparkle 1.5s ease-in-out infinite;
}
.ai-assistant-icon-wrapper {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(97, 119, 143, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}
.ai-assistant-icon {
  font-size: 14px;
  color: #61778f;
  transition: color 0.3s ease;
}
.ai-assistant-label {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
}
.ai-assistant-badge {
  font-size: 10px;
  font-weight: 600;
  color: #6366f1;
  background: #eef2ff;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
@keyframes ai-gradient-rotate {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes ai-sparkle {
  0%, 100% {
    transform: scale(1) rotate(0deg);
  }
  33% {
    transform: scale(1.1) rotate(8deg);
  }
  66% {
    transform: scale(1.1) rotate(-8deg);
  }
}
.category-image {
  height: 29px;
  width: auto;
  margin: 15px;
}
.category-icon {
  font-size: 24px;
  color: #f59e0b;
  margin: 15px;
  transition: color 0.3s ease;
}
.category-name {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
  margin-left: 0;
}
.collapsed .category-icon {
  color: #d97706;
}
.collapsed:hover .category-icon {
  color: #f59e0b;
}
.direct-menu-items {
  padding: 8px 0;
}
.direct-menu-items ::ng-deep app-sidenav-item {
  display: block;
}
.favorites-menu-items {
  padding: 0 24px;
}
.favorites-menu-items ::ng-deep app-sidenav-item {
  display: block;
}
.favorites-menu-items ::ng-deep app-sidenav-item .sidenav-item .mat-mdc-list-item {
  padding-left: 5px;
  padding-right: 40px !important;
  height: 34px;
}
.favorites-menu-items ::ng-deep app-sidenav-item .sidenav-item .mat-mdc-list-item .route-icon {
  margin-left: 5px;
}
mat-nav-list.mat-mdc-list-base {
  width: 280px;
}
mat-accordion.mat-accordion {
  width: 100%;
  margin-bottom: 0;
  border-top: 0;
}
.expansion-title {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  margin: 0;
  min-width: 350px;
}
::ng-deep .mat-expansion-panel .mat-expansion-panel-body {
  padding: 0 24px 5px;
}
.category-header {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  justify-content: space-between;
  transition: background-color 0.3s, border 0.3s;
  height: 75px;
  max-height: 60px;
}
.custom-caret {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-left: 2px solid #3e3e3e;
  border-bottom: 2px solid #3e3e3e;
  transform: rotate(-45deg);
  transition: transform 0.3s ease-in-out;
  margin-right: 15px;
}
.rotate {
  transform: rotate(135deg);
}
.favorites-item-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
}
.favorites-item-wrapper .remove-favorite-icon {
  display: none;
}
.favorites-item-wrapper:hover .remove-favorite-icon {
  display: flex;
}
.favorites-item {
  flex: 1 1 auto;
}
.remove-favorite-icon {
  position: absolute;
  right: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #d3d3d3;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s;
  font-size: 15px;
  z-index: 10;
  padding: 5px;
}
.remove-favorite-icon:hover {
  color: #ff7675;
  transform: scale(1.2) rotate(-10deg);
}
.locked-module {
  opacity: 0.6;
  cursor: pointer;
  transition: opacity 0.3s ease;
}
.locked-module:hover {
  opacity: 0.85;
}
.locked-module .category-image {
  filter: grayscale(40%);
}
.locked-module .lock-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: 15px;
}
.locked-module .lock-indicator .lock-icon {
  font-size: 12px;
  color: #9ca3af;
}
.locked-module .lock-indicator .tier-badge {
  font-size: 10px;
  font-weight: 600;
  color: #6366f1;
  background: #eef2ff;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
/*# sourceMappingURL=sidenav.component.css.map */
